import React, { useEffect, useContext } from "react";
import { PlaidContext } from "./context/PlaidContext";
import { plaidApi } from "./services/plaidApi";
import AppRoutes from "./routes/AppRoutes";

const App = () => {
  const { linkToken, dispatch, accessToken } = useContext(PlaidContext);

  useEffect(() => {
    if (accessToken) {
      return;
    }

    const fetchToken = async () => {
      try {
        const data = await plaidApi.createLinkToken();
        dispatch({ type: "SET_LINK_TOKEN", payload: data.link_token });
      } catch (error) {
        console.error("Error fetching link token:", error);
      }
    };

    fetchToken();
  }, [dispatch, accessToken]);

  return (
    <AppRoutes
      accessToken={accessToken}
      linkToken={linkToken}
    />
  );
};

export default App;
